export const genderOptions = [
  {
    id: 'other',
    labelI18n: 'registerView.accountForm.labels.genderOptionOther',
    value: 'other',
  },
  {
    id: 'male',
    labelI18n: 'registerView.accountForm.labels.genderOptionMale',
    value: 'male',
  },
  {
    id: 'female',
    labelI18n: 'registerView.accountForm.labels.genderOptionFemale',
    value: 'female',
  },
];

export const communicationPreferencesOptions = [
  {
    id: 'preference-email',
    labelI18n: 'registerView.accountForm.labels.communicationPreferenceOptionEmail',
    value: 'email',
  },
  {
    id: 'preference-phone',
    labelI18n: 'registerView.accountForm.labels.communicationPreferenceOptionPhone',
    value: 'phone',
  },
];

export const communicationLanguageOptions = [
  {
    id: 'en',
    labelI18n: 'registerView.accountForm.labels.communicationLanguageOptionEN',
    value: 'en',
  },
  {
    id: 'de',
    labelI18n: 'registerView.accountForm.labels.communicationLanguageOptionDE',
    value: 'de',
  },
];

export const situationOptions = [
  {
    id: 'A',
    labelI18n: 'registerView.accountForm.labels.situationOptions.employed',
    value: 'employed',
  },
  {
    id: 'B',
    labelI18n: 'registerView.accountForm.labels.situationOptions.unemployed',
    value: 'unemployed',
  },
  {
    id: 'C',
    labelI18n: 'registerView.accountForm.labels.situationOptions.training',
    value: 'training',
  },
  {
    id: 'D',
    labelI18n: 'registerView.accountForm.labels.situationOptions.selfEmployed',
    value: 'selfEmployed',
  },
  {
    id: 'E',
    labelI18n: 'registerView.accountForm.labels.situationOptions.student',
    value: 'student',
  },
  {
    id: 'F',
    labelI18n: 'registerView.accountForm.labels.situationOptions.civilServant',
    value: 'civilServant',
  },
  {
    id: 'G',
    labelI18n: 'registerView.accountForm.labels.situationOptions.pensioner',
    value: 'pensioner',
  },
  {
    id: 'H',
    labelI18n: 'registerView.accountForm.labels.situationOptions.other',
    value: 'other',
  },
];

export const countryOptions = [
  {
    id: 'A',
    labelI18n: 'registerView.accountForm.labels.countries.germany',
    value: 'de',
  },
  {
    id: 'B',
    labelI18n: 'registerView.accountForm.labels.countries.other',
    value: 'employed',
  },
];

export const helpOptions = [
  {
    id: 'A',
    value: 'Sales',
    labelI18n: 'contact.contactForm.options.sales',
  },
  {
    id: 'B',
    value: 'General help',
    labelI18n: 'contact.contactForm.options.help',
  },
  {
    id: 'C',
    value: 'Information',
    labelI18n: 'contact.contactForm.options.info',
  },
  {
    id: 'D',
    value: 'Account',
    labelI18n: 'contact.contactForm.options.account',
  },
  {
    id: 'E',
    value: 'Feedback',
    labelI18n: 'contact.contactForm.options.feedback',
  },
  {
    id: 'F',
    value: 'Other',
    labelI18n: 'contact.contactForm.options.other',
  },
];
